import Chart from 'chart.js';

/**
 * Vanilla JS Chart.js initialization.
 * Discovers <canvas data-chart> elements and initializes Chart.js instances.
 *
 * Supported attributes:
 *   data-chart          - presence triggers initialization
 *   data-chart-type     - chart type: "pie", "doughnut", "line", "bar", etc.
 *   data-chart-data     - JSON string of chart data (labels, datasets)
 *   data-chart-options  - JSON string of chart options
 */

function initChart(canvas) {
    if (canvas._chartInstance) return;

    const type = canvas.dataset.chartType || 'doughnut';

    let data = {};
    if (canvas.dataset.chartData) {
        try {
            data = JSON.parse(canvas.dataset.chartData);
        } catch (e) {
            console.warn('Invalid data-chart-data JSON', e);
            return;
        }
    }

    let options = {};
    if (canvas.dataset.chartOptions) {
        try {
            options = JSON.parse(canvas.dataset.chartOptions);
        } catch (e) {
            console.warn('Invalid data-chart-options JSON', e);
        }
    }

    const ctx = canvas.getContext('2d');
    const chart = new Chart(ctx, {
        type: type,
        data: data,
        options: options
    });

    canvas._chartInstance = chart;
}

function initAll(root) {
    const canvases = (root || document).querySelectorAll('canvas[data-chart]');
    canvases.forEach((canvas) => {
        if (!canvas._chartInstance) {
            initChart(canvas);
        }
    });
}

// Auto-init on DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => initAll());

// Re-init after HTMX swaps
document.body.addEventListener('htmx:afterSettle', (e) => {
    initAll(e.detail.target);
});

// Export for manual use
window.initCharts = initAll;
